import { render, staticRenderFns } from "./amountlogs.vue?vue&type=template&id=2c54d23e&"
import script from "./amountlogs.vue?vue&type=script&lang=js&"
export * from "./amountlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports